import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
  DirectionsRenderer,
  Polyline,
} from "@react-google-maps/api";

import { formatRelative } from "date-fns";
import "./Map-CSS/index.css";
import mapStyles from "./Map-Styles/mapStyles";
import { googleApiKey, invokeApi } from "../../bl_libs/invokeApi";
import {
  addressARedImage,
  trackingTruckImage,
  truckTrackingBtnImage,
  addressBRedImage,
  addressCRedIcon,
  addressDRedIcon,
  addressERedIcon,
  addressFRedIcon,
  blackBackArrowImage,
} from "../../assets";
import { withRouter } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { useSockets } from "../../Context/Context-Sockets/ContextSockets";
import { useSnakbar } from "../../Context/Context-Snakbar/ContextSnackbar";

const libraries = ["places"];
const mapContainerStyle = {
  height:
    window.innerWidth < 769 ? window.innerHeight : window.innerHeight - 60,
  width: "100%",
};
const options = {
  // styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: true,
};
const center = {
  lat: 33.9679,
  lng: -118.297,
};

function LiveMapTracking(props) {
  const { currentPosition, setCurrentPosition } = useSockets();
  const { showErrorSnak } = useSnakbar();
  const [requestData, setRequestData] = useState();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleApiKey,
    libraries,
  });

  const [markers, setMarkers] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const [directions, setDirections] = useState([]);
  const [truckBox, setTruckBox] = useState(false);
  const [path, setPath] = useState([]);

  // const [currentPosition, setCurrentPosition] = useState(null);

  const addressIcon = (i) => {
    return i === 0
      ? addressARedImage
      : i === 1
      ? addressBRedImage
      : i === 2
      ? addressCRedIcon
      : i === 3
      ? addressDRedIcon
      : i === 4
      ? addressERedIcon
      : addressFRedIcon;
  };

  const fetchRequestDetails = () => {
    let requestObj = {
      path: "/api/customer/customer_request_detail",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log("RESPONSE", res);
      if (res.code === 200) {
        console.log(res.request_address);

        SetAllMarkers(res.request_address);
        SetAllDirections(res.request_address);
        setRequestData(res);
      } else {
        alert(res.message);
      }
    });
  };

  const GetTrackingLastLocations = () => {
    return new Promise(function (myResolve, myReject) {
      let requestObj = {
        path: "/app_api/get_tracking",
        method: "POST",
        headers: {
          "x-sh-auth": localStorage.getItem("token"),
        },
      };
      let postData = {
        request_id: `${props.match.params.requestId}`,
      };
      requestObj["postData"] = postData;
      invokeApi(requestObj).then((res) => {
        if (res.code === 200) {
          console.log(
            res.tracking_data[res.tracking_data.length - 1],
            "GetTrackingLocations"
          );

          const pathList = res.tracking_data.map((location) => {
            return {
              lat: Number(location.latitude),
              lng: Number(location.longitude),
            };
          });

          console.log(pathList, "Path list");
          setPath(pathList);

          const lastLocation =
            res.tracking_data.length === 0
              ? null
              : res.tracking_data[res.tracking_data.length - 1];
          myResolve(lastLocation);
        } else {
          //showErrorSnak(res.message);
        }
      });
    });
  };

  const onMapClick = React.useCallback((e) => {
    /* ---------------------------------------------------
            CODE FOR CREATING ON MAP CLICK MARKERS
    ----------------------------------------------------- */
    // const location = {
    //   lat: e.latLng.lat(),
    //   lng: e.latLng.lng(),
    // };
    // setCurrentPosition(location);
  }, []);

  const SetNewMarkerOnMap = (marker) => {
    setMarkers((current) => [...current, marker]);
  };

  const SetDirection = (origin, destination, id) => {
    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections((current) => [
            ...current,
            { path: result, status: true, id },
          ]);
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  };

  const SetAllMarkers = (addressList) => {
    addressList.map((address, i) => {
      const markerObject = {
        ...address,
        lat: address.latitude,
        lng: address.longitude,
        icon: addressIcon(i),
      };

      SetNewMarkerOnMap(markerObject);
    });
  };

  const SetAllDirections = (addressList) => {
    if (addressList.length === 1) return;
    for (let i = 0; i < addressList.length - 1; i++) {
      //geting start and end positions
      const origin = {
        lat: addressList[i].latitude,
        lng: addressList[i].longitude,
      };
      const destination = {
        lat: addressList[i + 1].latitude,
        lng: addressList[i + 1].longitude,
      };

      const id =
        i === 0
          ? "a-b"
          : i === 1
          ? "b-c"
          : i === 2
          ? "c-d"
          : i === 3
          ? "d-e"
          : i === 4
          ? "e-f"
          : addressFRedIcon;

      SetDirection(origin, destination, id);
    }
  };

  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  // const panTo = React.useCallback(({ lat, lng }) => {
  //   mapRef.current.panTo({ lat, lng });
  //   mapRef.current.setZoom(24);
  // }, []);

  const setDirectionsStatus = () => {
    let temp = directions.map((direction, i) => {
      if (direction.id === "b-c") {
        return {
          ...direction,
          status: false,
        };
      } else {
        return direction;
      }
    });
    console.log(temp);
    setDirections(temp);
  };

  const currentLocationMarker = useRef(null);

  const ShowTruckCurrentLocation = React.useCallback(
    ({ lat, lng }) => {
      console.log(currentPosition, "Focus lat lng");
      if (currentPosition) {
        mapRef.current.panTo(currentPosition);
        mapRef.current.setZoom(17);
      } else {
        showErrorSnak("Please wait for forman location");
        // GetTrackingLocations();
      }
    },
    [currentPosition]
  );
  useEffect(() => {
    if (currentPosition === null) {
      GetTrackingLastLocations().then((data) => {
        // alert(data);
        if (data) {
          setCurrentPosition({
            lat: Number(data.latitude),
            lng: Number(data.longitude),
          });
        }
      });
    } else {
      setPath((current) => [...current, currentPosition]);
    }
  }, [currentPosition]);

  useEffect(() => {
    console.log("PATH UPDATED", path);
    if (window.google) {
      const lastLocation = path.length === 0 ? null : path[path.length - 1];
      const diffLastLocation = path.length < 2 ? null : path[path.length - 10];

      if (!lastLocation || !diffLastLocation) {
        return;
      }
      const point1LatLng = new window.google.maps.LatLng(
        lastLocation.lat,
        lastLocation.lng
      );
      const point2LatLng = new window.google.maps.LatLng(
        diffLastLocation.lat,
        diffLastLocation.lng
      );

      if (window.google.maps.geometry) {
        const angle = window.google.maps.geometry.spherical.computeHeading(
          point1LatLng,
          point2LatLng
        );
        const actualAngle = angle;
        console.log(actualAngle, "actualAngle");
        const markerUrl = "/tracking-truck.svg";
        const marker = document.querySelector(`[src="${markerUrl}"]`);
        if (marker) {
          // when it hasn't loaded, it's null
          marker.style.transform = `rotate(${actualAngle}deg)`;
        }
        console.log(marker, "marker");
        console.log(currentLocationMarker, "currentLocationMarker");
      }
    }
  }, [path]);
  useEffect(() => {
    fetchRequestDetails();
  }, []);

  if (loadError) return "Error";
  if (!isLoaded)
    return (
      <div style={{ width: "100%" }}>
        <div className="Circular-Progress">
          <CircularProgress />
        </div>
      </div>
    );

  return (
    <div style={{ width: "100%" }}>
      {/* <Locate panTo={panTo} SetMyCurrentLocation={SetMyCurrentLocation} /> */}
      <div className="heading-text tracking-right-box">
        <div className="order-heading">
          <img
            className="pointer-point pr-2"
            src={blackBackArrowImage}
            onClick={() => props.history.goBack()}
          />{" "}
          ORDER # {props.match.params.requestId}
        </div>
        <div className="moving-heading">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
          </svg>{" "}
          {currentPosition ? "Moving" : "Tracking"}
        </div>
      </div>
      <img
        className="locate trackingTruckButton"
        onClick={ShowTruckCurrentLocation}
        src={truckTrackingBtnImage}
        alt="trackingTruckImage"
      />
      {/* <Search panTo={panTo} /> */}

      <GoogleMap
        id="map"
        mapContainerStyle={mapContainerStyle}
        zoom={6}
        center={center}
        options={options}
        onClick={onMapClick}
        onLoad={onMapLoad}
      >
        {/* {path.length > 0 && (
          <Polyline path={path} options={{ strokeColor: "#C4314B" }} />
        )} */}
        {markers.map((marker, i) => (
          <Marker
            key={i}
            position={{ lat: marker.lat, lng: marker.lng }}
            // onClick={() => {
            //   setSelected(marker);
            // }}
            icon={{
              url: marker.icon,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
              scaledSize: new window.google.maps.Size(30, 30),
            }}
          />
        ))}

        {currentPosition && (
          <Marker
            position={{ lat: currentPosition.lat, lng: currentPosition.lng }}
            onClick={() => setTruckBox(true)}
            ref={currentLocationMarker}
            icon={{
              url: "/tracking-truck.svg",
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(45, 40),
              scaledSize: new window.google.maps.Size(90, 90),
            }}
          />
        )}

        {currentPosition && truckBox && (
          <InfoWindow
            position={{ lat: currentPosition.lat, lng: currentPosition.lng }}
            onCloseClick={() => setTruckBox(false)}
          >
            <div style={{ width: "100%" }}>
              <img src={truckTrackingBtnImage}></img>
              <br></br>
              <span>Live Location</span>
            </div>
          </InfoWindow>
        )}

        {selected ? (
          <InfoWindow
            position={{ lat: selected.lat, lng: selected.lng }}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div style={{ width: "100%" }}>
              <img src={selected.icon}></img>
              <span>{selected.complete_address}</span>

              <div className="pt-2">
                <span className="dark-grey-color small-sub-title">
                  Address Type :
                </span>
                <span className="black-color small-font-size pl-3">
                  {selected.address_type === 1 ? "PICK UP" : "DROP OFF"}
                </span>
              </div>
              <div className="pt-2">
                <span className="dark-grey-color small-sub-title">
                  About Address:
                </span>
                <span className="black-color small-font-size pl-3">
                  {selected.address_detail ? selected.address_detail : "N/A"}
                </span>
              </div>
            </div>
          </InfoWindow>
        ) : null}

        {directions.length !== 0 &&
          directions.map(
            (direction, i) =>
              direction.status && (
                <DirectionsRenderer
                  key={i}
                  options={{
                    suppressMarkers: true,
                    // markerOptions: {
                    //   icon: addressARedIcon,
                    //   position: { lat: 40.756795, lng: -73.954298 },
                    // },
                    polylineOptions: {
                      strokeColor: "#C4314B",
                    },
                  }}
                  directions={direction.path}
                ></DirectionsRenderer>
              )
          )}
      </GoogleMap>
    </div>
  );
}

// function Locate({ panTo, SetMyCurrentLocation }) {
//   return (
//     <img
//       className="locate trackingTruckButton"
//       onClick={SetMyCurrentLocation}
//       src={truckTrackingBtnImage}
//       alt="trackingTruckImage"
//     />
//   );
// }

export default withRouter(LiveMapTracking);
